'use client';

import { useTranslations } from 'next-intl';

interface LanguageSwitcherProps {
  currentLocale: string;
  isOpen: boolean;
  onToggle: () => void;
}

const SpeechBubbleIcon = ({ label }: { label: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0325 3H3.96748C2.88087 3 2 3.88087 2 4.96748V17.3252C2 18.4118 2.88087 19.2927 3.96748 19.2927H6.43902C6.84313 19.2927 7.17073 19.6203 7.17073 20.0244V22.2683L10.9431 19.4398C11.1056 19.3196 11.3014 19.2537 11.5 19.2439L11.3821 19.2293H20.0325C21.1191 19.2293 22 18.3484 22 17.2618V4.96748C22 3.88087 21.1191 3 20.0325 3ZM3.96748 4.46341H20.0325C20.3109 4.46341 20.5366 4.68909 20.5366 4.96748V17.3252C20.5366 17.6036 20.3109 17.8293 20.0325 17.8293H11.3821L11.2878 17.8354C11.1633 17.8516 11.0444 17.8996 10.9431 17.9756L7.17073 20.8049V18.561C7.17073 18.1569 6.84313 17.8293 6.43902 17.8293H3.96748C3.68909 17.8293 3.46341 17.6036 3.46341 17.3252V4.96748C3.46341 4.68909 3.68909 4.46341 3.96748 4.46341Z"
      fill="currentColor"
    />
    <text
      x="12"
      y="13.5"
      textAnchor="middle"
      fontSize="8"
      fontWeight="700"
      fill="currentColor"
      fontFamily="inherit"
    >
      {label}
    </text>
  </svg>
);

export const LanguageSwitcher = ({
  currentLocale,
  isOpen,
  onToggle,
}: LanguageSwitcherProps) => {
  const t = useTranslations('header');

  return (
    <button
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-haspopup="menu"
      aria-label={t('selectLanguage')}
      className="flex flex-col items-center gap-0.5 p-1 transition-opacity hover:opacity-80"
    >
      <SpeechBubbleIcon label={currentLocale.toUpperCase()} />
      <span
        className={[
          'h-0.5 w-full rounded-full transition-colors duration-200',
          isOpen ? 'bg-primary' : 'bg-transparent',
        ].join(' ')}
      />
    </button>
  );
};
